import client from './api-client';

export const servicePresignaArchivo = async (query) => {
    const response = await client.get(`archivos/presign?q=${query}`);

    if (response.status === 200 && response.data.code === 1) return response.data.object;
    else throw new Error(response.data.message);
}
